import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { BORDER_RADIUS } from "../../../utils/constants";

// eslint-disable-next-line
export const INSIGHT_SEVERITY_CONFIG = {
  critical: {
    icon: ErrorOutlineIcon,
    borderColor: "#f5c6cb",
    backgroundColor: "#fff5f5",
    iconColor: "#c5221f",
  },
  warning: {
    icon: LightbulbOutlinedIcon,
    borderColor: "#ffe082",
    backgroundColor: "#fffbf0",
    iconColor: "#e37400",
  },
  positive: {
    icon: TrendingUpIcon,
    borderColor: "#b7e1cd",
    backgroundColor: "#f6fff8",
    iconColor: "#137333",
  },
};

const InsightCard = ({ insight, action = null }) => {
  const severity =
    insight.severity ||
    (insight.polarity === "negative" ? "critical" : "positive");
  const config =
    INSIGHT_SEVERITY_CONFIG[severity] || INSIGHT_SEVERITY_CONFIG.warning;
  const Icon = config.icon;

  return (
    <Box
      data-pdf-card
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        p: 1.5,
        borderRadius: `${BORDER_RADIUS * 2}px`,
        border: `1px solid ${config.borderColor}`,
        backgroundColor: config.backgroundColor,
      }}
    >
      <Box sx={{ display: "flex", gap: 1.5 }}>
        <Icon sx={{ color: config.iconColor, mt: 0.25, flexShrink: 0 }} />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.5 }}>
            {insight.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {insight.description}
          </Typography>
        </Box>
      </Box>
      {action}
    </Box>
  );
};

export default InsightCard;
